import SmsScreen from "components/shared/SmsScreen"
import { EXISTING_PHONE_NUMBER_TEXT } from "shared/constants"
import { useHistory } from "react-router-dom"
import {
  useForceAuthEffect,
  useVerificationRedirectEffect
} from "components/Login/hooks"
import warningIcon from "./assets/warning-icon.svg"

const ExistingPhoneNumber = () => {
  useForceAuthEffect({ authUrl: "/login" })
  useVerificationRedirectEffect()
  const history = useHistory()

  const handleContinue = () => {
    history.replace("/sms-verify")
  }

  return (
    <SmsScreen
      heading={EXISTING_PHONE_NUMBER_TEXT.heading}
      description={EXISTING_PHONE_NUMBER_TEXT.description}
      icon={warningIcon}
      buttons={[
        {
          text: EXISTING_PHONE_NUMBER_TEXT.continueButton,
          primary: true,
          onClick: handleContinue
        }
      ]}
      showLogoutButton
    />
  )
}

export default ExistingPhoneNumber
